import React from 'react';

const PromoBanner: React.FC = () => {
  return null;
};

export default PromoBanner;
